import { defineMessages } from '@jutro/locale';

export default defineMessages({
    language: {
        id: 'gateway.views.preferences.Language',
        defaultMessage: 'Language',
    },
    Preferences: {
        id: 'portal.index.Preferences',
        defaultMessage: 'Preferences',
    },
    accountSettings: {
        id: 'gateway.views.preferences.Account Settings',
        defaultMessage: 'Account Settings'
    },
    primaryProducerCode: {
        id: 'gateway.views.preferences.Primary Producer Code',
        defaultMessage: 'Primary Producer Code'
    },
    group: {
        id: 'gateway.views.preferences.Group',
        defaultMessage: 'Group'
    },
    selectGroup: {
        id: 'gateway.views.preferences.Select Group',
        defaultMessage: 'Select Group'
    },
    producerCode: {
        id: 'gateway.views.preferences.Producer Code',
        defaultMessage: 'Producer Code'
    },
    selectProducerCode: {
        id: 'gateway.views.preferences.Select Producer Code',
        defaultMessage: 'Select Producer Code'
    },
    save: {
        id: 'gateway.views.preferences.Save',
        defaultMessage: 'Save'
    },
    preferencesSuccess: {
        id: 'gateway.views.preferences.Your preferences have been updated',
        defaultMessage: 'Your <b>preferences</b> have been updated.'
    },
    preferencesFail: {
        id: 'gateway.views.preferences.Your request failed Please try again',
        defaultMessage: 'Your request failed. Please try again.'
    },
});
